import type { Filters, SnapshotId } from '@ipfabric/utils';
import { ApiTableView } from 'components/ApiTable/components/ApiTableView';
import type { ApiTableModel } from 'components/ApiTable/model/ApiTableModel';
import {
  type UseApiTableProps,
  useApiTable,
} from 'components/ApiTable/model/useApiTable';
import { type FC, memo } from 'react';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';

interface Props {
  snapshotId?: SnapshotId | null;
  filter?: Filters;
}

export const useDeviceSnapshotAttributesTable = (
  props: Partial<UseApiTableProps>,
): ApiTableModel => {
  const deviceAttributesEndpoint = useTableEndpoint({
    apiEndpoint: '/tables/snapshot-attributes',
  });
  return useApiTable({
    endpoint: deviceAttributesEndpoint,
    ...props,
  });
};

const BareDeviceSnapshotAttributesTable: FC<Props> = (props) => {
  const model = useDeviceSnapshotAttributesTable({
    snapshotId: props.snapshotId,
    initialFilters: props.filter,
  });

  return <ApiTableView borderless className='flex-1' model={model} />;
};

export const DeviceSnapshotAttributesTable = memo(
  BareDeviceSnapshotAttributesTable,
);
